import React from 'react';
import { EmailCaptureForm } from '../../components/EmailCaptureForm';
import './LandingPage.css';
import { BsActivity, BsHeartPulse, BsGraphUp } from 'react-icons/bs';

export default function InjuryLandingPage() {
  return (
    <div className="landing-page">
      <div className="landing-hero" data-fast-scroll="injury_hero_view">
        <img src="/images/GymBuddy.png" alt="GymBuddy" className="landing-logo" onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/images/PokerBuddy.png'; }} />
        <h1 className="landing-title">Train Safely After Injury</h1>
        <p className="landing-subtitle">
          Don't let an injury stop your progress. Get customized workout plans that work around your limitations and help you rebuild strength.
        </p>

        {/* Hero Image - Part of CTA */}
        <div className="hero-image-container">
          <img src="/images/Injury.png" alt="Train Safely After Injury" className="hero-image" />
        </div>

        <EmailCaptureForm campaign="injury" placeholder="Enter your email" />
      </div>

      <div className="landing-content" data-fast-scroll="injury_benefits_view" data-fast-scroll-threshold="0.5">
        <div className="benefit-grid">
          <div className="benefit-card">
            <div className="benefit-title">
              <BsActivity style={{ color: '#d32f2f' }} />
              <span>Smart Modifications</span>
            </div>
            <p className="benefit-desc">
              Can't do squats? No problem. We automatically suggest safe, effective alternatives that target the same muscles without the pain.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsHeartPulse style={{ color: '#d32f2f' }} />
              <span>Safe Progression</span>
            </div>
            <p className="benefit-desc">
              Rebuild your strength gradually. Our algorithms adjust intensity based on your feedback to prevent re-injury.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsGraphUp style={{ color: '#d32f2f' }} />
              <span>Track Recovery</span>
            </div>
            <p className="benefit-desc">
              Monitor your strength returning over time. See visual progress as you get back to your peak performance.
            </p>
          </div>
        </div>

        <div className="app-preview-section" data-fast-scroll="injury_preview_view">
          <h2 className="app-preview-title">The Recovery Toolkit</h2>
          <div className="app-preview-grid">
            <img src="/images/image.png" alt="App Preview 1" className="app-preview-image" />
            <img src="/images/image1.png" alt="App Preview 2" className="app-preview-image" />
            <img src="/images/image3.png" alt="App Preview 3" className="app-preview-image" />
            <img src="/images/image4.png" alt="App Preview 4" className="app-preview-image" />
          </div>
        </div>
      </div>

      <footer className="landing-footer" data-fast-scroll="injury_footer_view">
        © {new Date().getFullYear()} GymBuddy. All rights reserved.
      </footer>
    </div>
  );
}
